import { ChainConfig } from "@silo/types";
import { satisfies } from "effect/Function";

export const anvil = satisfies<ChainConfig>()({ tokens: {} } as const);
